import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyD3m0bhfMzSEfCDo5_xvdEPv_ueg8uivMA",
    authDomain: "myapp01-7b9bf.firebaseapp.com",
    projectId: "myapp01-7b9bf",
    storageBucket: "myapp01-7b9bf.appspot.com",
    messagingSenderId: "799160179060",
    appId: "1:799160179060:web:11dc34ed68d4cbcfb63421",
    measurementId: "G-YJKXJ37FD2"
  };


const firebaseApp = firebase.initializeApp(firebaseConfig);


export const firestore = firebaseApp.firestore();

export const storage = firebase.storage().ref();
export const auth = firebaseApp.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export default firebaseApp;